import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getFileSearch = get('guest.components.fileSearch');

export const getGuestFileSearchQuery = createSelector(
  getFileSearch,
  get('query')
);
